import { useCentralizedMe } from '@crehana/auth';
import type { EventType, TMilestoneEventItem } from '@crehana/compass.dashlets';

import { useGetMilestonesEventsQuery } from './graphql/get-milestones-events.v5.mock.generated';

const convertToCamelCase = (data: unknown): TMilestoneEventItem[] => {
  // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
  if (!Array.isArray(data)) return [];

  return data.map(item => ({
    id: item.id,
    user: {
      fullName: item.user?.full_name || '',
      photoUrl: item.user?.photo_url || undefined,
      role: item.user?.role || '',
    },
    description: item.description || '',
    date: item.date || '',
    type: item.type as EventType,
  }));
};

export const useGetMilestonesEvents = () => {
  const { me } = useCentralizedMe();
  const { data, loading, error, refetch } = useGetMilestonesEventsQuery({
    variables: {
      input: { centralized_organization_id: me?.organization.id.toString() },
    },
    context: { clientName: 'mock.v5' },
  });

  const milestonesData = data?.hris?.get_milestones_events;
  const todayEvents =
    milestonesData?.__typename === 'MilestonesEventsData'
      ? convertToCamelCase(milestonesData.today_events)
      : [];
  const nextEvents =
    milestonesData?.__typename === 'MilestonesEventsData'
      ? convertToCamelCase(milestonesData.next_events)
      : [];

  return {
    loading,
    error,
    dataMilestonesEvents: { todayEvents, nextEvents },
    refetch,
  };
};
